import { render, staticRenderFns } from "./JudgingCriteriaCreate.vue?vue&type=template&id=1549fa4f&scoped=true"
import script from "./JudgingCriteriaCreate.vue?vue&type=script&lang=js"
export * from "./JudgingCriteriaCreate.vue?vue&type=script&lang=js"
import style0 from "./JudgingCriteriaCreate.vue?vue&type=style&index=0&id=1549fa4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1549fa4f",
  null
  
)

export default component.exports